import React, { useCallback, useEffect, useState } from 'react'
import PlayStoreIcon from '../../assets/icons/playStore.icon'
import CustomButton from '../../shared/customButton/CustomButton'
import { Carousel } from 'react-bootstrap'
import AppleIcon from '../../assets/icons/apple.icon'
import { ApplicationProviderRouteEnum } from '../../shared/enums/application-enum'
import { staticContent } from '../../shared/static/StaticContent'
import imagesPool from '../../utils/heroImages'

export interface BannerSectionProps {
  browseFrom: string
}

function BannerSection({ browseFrom }: BannerSectionProps) {
  const [imageList, setImageList] = useState<any>(browseFrom === ApplicationProviderRouteEnum.UK ? [] : imagesPool.filter((x) => !x.isUk)
  )

  const [mainText, setMainText] = useState(
    browseFrom === ApplicationProviderRouteEnum.UK
      ? ''
      : staticContent.AU.heroTitle
  )
  const [isColorChange, setIsColorChange] = useState(false)
  const [secondaryText, setSecondaryText] = useState(
    browseFrom === ApplicationProviderRouteEnum.UK
      ? ''
      : staticContent.AU.heroSubTitle
  )

  const changeContent = useCallback((contentsTo) => {
    switch (contentsTo.toUpperCase()) {
      case '/AU':
        setMainText(staticContent.AU.heroTitle);
        setSecondaryText(staticContent.AU.heroSubTitle);
        setIsColorChange(false);
        break
      case '/UK':
        setMainText(staticContent.UK.heroTitle);
        setSecondaryText(staticContent.UK.heroSubTitle);
        setIsColorChange(false);
        const imgList = imagesPool.filter((x) => x.isUk);
        setImageList(imgList);
        break
      case '/US':
        setMainText(staticContent.US.heroTitle);
        setSecondaryText(staticContent.US.heroSubTitle);
        setIsColorChange(true);
        break
      case '/CA':
        setMainText(staticContent.CA.heroTitle);
        setSecondaryText(staticContent.CA.heroSubTitle);
        setIsColorChange(true);
        break
      default:
        setMainText(staticContent.AU.heroTitle);
        setSecondaryText(staticContent.AU.heroSubTitle);
        setIsColorChange(false);
        break
    }
  }, [])

  useEffect(() => {
    changeContent(browseFrom)
  }, [browseFrom, changeContent])

  const handleSlide = (eventKey: number) => {
    if (eventKey < imagesPool.length && imagesPool[eventKey].isUs) {
      changeContent('/US')
    } else if (eventKey < imagesPool.length && imagesPool[eventKey].isCa) {
      changeContent('/CA')
    } else {
      changeContent(browseFrom)
    }
  }

  const handleButtonClick = (url: string) => {
    window.open(url, '_blank', 'noreferrer')
  }

  return (
    <div className="image-box">
      <div className="background-shade"></div>
      <Carousel indicators={false} onSlide={handleSlide} className="carousal">
        {imageList.map((item: any, index: number) => (
          <Carousel.Item key={`heroImage-${index}`}>
            <img
              className="img-fluid hero-image"
              src={item.src}
              alt={`heroImage-${index}`}
              loading={item.eager ? 'eager' : 'lazy'}
            />
          </Carousel.Item>
        ))}
      </Carousel>
      <div className={`center-text  ${isColorChange ? 'change-color' : null}`}>
        {browseFrom === ApplicationProviderRouteEnum.UK || browseFrom === ApplicationProviderRouteEnum.AU ?
          (
            <>
              <div className="mobile-app-download--button-container">
                <CustomButton
                  text="App Store"
                  varient="small"
                  onClick={() =>
                    handleButtonClick(
                      'https://apps.apple.com/us/app/rail-online/id6446792610'
                    )
                  }
                  backgroundColor="black"
                  className="m-2"
                  icon={<AppleIcon />}
                />
                <CustomButton
                  text="Play Store"
                  varient="small"
                  backgroundColor="black"
                  className="m-2"
                  onClick={() =>
                    handleButtonClick(
                      'https://play.google.com/store/apps/details?id=com.railonlinemobile'
                    )
                  }
                  icon={<PlayStoreIcon />}
                />
              </div>
              <h2 className="text-white fs-5 mt-2">
                Download the free Rail Online App to compare, <br />
                plan and book your next rail adventure.
              </h2>
            </>
          ) : (
           <>          
            </>
          )

        }


      </div>


    </div>

  )
}

export default BannerSection
